import AppComponents from './components/root/appcomponents';

function App() {
	return <AppComponents />;
}

export default App;
